import { render, staticRenderFns } from "./PlanCardCollapsed.vue?vue&type=template&id=169e8dc2&scoped=true"
import script from "./PlanCardCollapsed.vue?vue&type=script&lang=js"
export * from "./PlanCardCollapsed.vue?vue&type=script&lang=js"
import style0 from "./PlanCardCollapsed.vue?vue&type=style&index=0&id=169e8dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169e8dc2",
  null
  
)

export default component.exports